"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find-index");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {},
  props: {
    menusList: Array,
    name: String
  },
  data: function data() {
    return {
      list: [],
      actheight1: false,
      actheight: false,
      act: 0,
      act1: 0,
      act2: 0
    };
  },
  methods: {
    change: function change(tit, remark, v, j) {
      this.list[j].act = v;
      this.$emit('curLable', tit, remark);
    },
    zhankai: function zhankai(j) {
      this.list[j].actheight = !this.list[j].actheight;
    }
  },
  watch: {
    menusList: {
      handler: function handler(o, n) {
        this.list = this.menusList;
      },
      deep: true
    }
  },
  computed: {},
  created: function created() {
    this.list = this.menusList;
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      // 当传入name时，默认选择对应的菜单项
      if (_this.name) {
        _this.list.forEach(function (menu, index) {
          var itemIndex = menu.itemList.findIndex(function (item) {
            return item.name === _this.name;
          });
          if (itemIndex !== -1) {
            menu.act = itemIndex;
          }
        });
      }
    });
  }
};